// 导入合并reducer的依赖
import { combineReducers } from "redux";

// 导入 登录 模块的 reducer
import A0layout from "./layout";
import A1Home from "./A1Home";

// 合并 reducer
const rootReducer = combineReducers({
  A0layout,
  A1Home
});

// 默认导出
export default rootReducer;
